


export const phoneNumberCleaner = (phoneNumber) => {
    return phoneNumber.replace('+', '');
  }